import { render, staticRenderFns } from "./FormEventTickets.vue?vue&type=template&id=a1678604&"
import script from "./FormEventTickets.vue?vue&type=script&lang=js&"
export * from "./FormEventTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1678604')) {
      api.createRecord('a1678604', component.options)
    } else {
      api.reload('a1678604', component.options)
    }
    module.hot.accept("./FormEventTickets.vue?vue&type=template&id=a1678604&", function () {
      api.rerender('a1678604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/tickets/FormEventTickets.vue"
export default component.exports